import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(protected)/management/dashboard/")({
  component: ManagementDashboard,
});

function ManagementDashboard() {
  return <div className="p-6">Management Dashboard</div>;
}
